export default __webpack_public_path__ + "static/media/oberbayern_dark.b5539879.png";